import { render, staticRenderFns } from "./bookingNew.vue?vue&type=template&id=dbc89f6a&"
import script from "./bookingNew.vue?vue&type=script&lang=js&"
export * from "./bookingNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbc89f6a')) {
      api.createRecord('dbc89f6a', component.options)
    } else {
      api.reload('dbc89f6a', component.options)
    }
    module.hot.accept("./bookingNew.vue?vue&type=template&id=dbc89f6a&", function () {
      api.rerender('dbc89f6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/bookingNew.vue"
export default component.exports